import Config from '../../config';
import Grid from '../../view/grid';
import Template from './types.form.template';

import { hashify } from '../../utils/arrays';





export default Template.extend( {

    template: 'module/refbooks/types.form.bound-roles',

    url() {
        return this.options.type.id
            ? `types/${this.options.type.id}/edit/bound-roles`
            : `types/new/bound-roles`;
    },

    open({ type, original, bindings }) {
        const {
            rolesPage = 1, rolesLimit = 10,
            rolesSort = 'name', rolesDirection = 'asc',
            rolesSearch = '',
        } = this.state() || {};

        this.setState( { 
            rolesPage, rolesLimit, rolesSort, rolesDirection, rolesSearch,
        } );

        return Template.prototype.open.call( this, { type, original, bindings } );
    },

    start() {
        Template.prototype.start.call( this );

        this.listenTo( this.options.type, 'change:role_ids change:__all_roles_available',
            () => this.Buttons.render() );

        return this;
    },

    serialize() {
        const { rolesSort, rolesDirection, rolesSearch, } = this.state();
        const { filtered, resulted, } = this.options;

        return {
            ...Template.prototype.serialize.call( this ),
            // TODO in Template?
            roles: filtered,
            rows: resulted,
            rolesSearch, rolesSort, rolesDirection,
        };
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;

            return this.setState( { rolesPage: 1, rolesSort: sort, rolesDirection: direction, } ),
                this.reSortGrid().then( () => this.reFilterGrid( this ) )
                    // hack: to rerender grid caption with order direction
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

        'click .-toggle-binding'({currentTarget}) {
            const { id } = currentTarget.dataset;
            const { type, filtered, } = this.options;

            const needAppend = currentTarget.checked;
            const oldRoles = type.get( 'role_ids' );
            const newRoles = needAppend
                ? [...oldRoles, id]
                : oldRoles.filter( itemId => itemId != id );

            type.set( 'role_ids', newRoles );

            const ids = hashify( newRoles );
            this.$( '.-toggle-all' )[0].checked = filtered.every( role => ids[role.id] );
        },

        'click .-toggle-all'({currentTarget}) {
            const value = currentTarget.checked;
            const { type, filtered } = this.options;

            const ids = filtered.models.map( item => item.id );
            const h = hashify( ids );
            const drained = type.get( 'role_ids' )
                .filter( id => !h[id] );

            type.set( 'role_ids', value
                ? [...drained, ...ids]
                : [...drained] );

            this.$( '.-toggle-binding' ).prop( 'checked', value );
        },

        'click .-toggle-all-roles-available'({currentTarget}) {
            // TODO the same in StickersGrid
            if (!currentTarget.checked)
                if (this.model.get( 'role_ids' ) == null)
                    this.model.set( 'role_ids', [] );
                else
                    // hack: undefined instead of false to make no diff with default value
                    this.model.set( '__all_roles_available', undefined );
            else
                this.model.set( '__all_roles_available', true );

            // TODO .disable()/.enable()
            if (this.model.get( 'role_ids' ) == null || this.model.get( '__all_roles_available' )) 
                this.RolesGrid.$el.addClass( 'disabled' );
            else
                this.RolesGrid.$el.removeClass( 'disabled' );
        },

    },

    [Template.event( 'Paging:page')](page) {
        return this.setState( { rolesPage: +page, } ),
            this.reFilterGrid( this ),
            this.navigated();
    },

    [Template.event( 'Search:search')](rolesSearch) {
        return this.setState( { rolesSearch, rolesPage: 1, } ), 
            this.reFilterGrid( this ),
            this.navigated();
    },

    reSortGrid() {
        const { rolesSort: sort, rolesDirection: direction, } = this.state();

        return Grid.sort( { sort, direction }, 
            this.options.roles, this.options.sorted, )
    },

    reFilterGrid() {
        const { rolesPage: page, rolesSearch: search, rolesLimit: limit } = this.state();
        const { type, sorted, filtered, resulted, } = this.options;

        Grid.filter( { page, search, limit },
            type.get( 'cluster' ), 
            sorted, filtered, resulted,
            // additional filtering by role cluster/type cluster
            role => {
                // chief admin/inspector can see all roles
                if (Config.level() === 'GLOBAL')
                    return true;

                // local type -> standard filtering is enough
                if (type.get( 'cluster' ) !== null)
                    return true;

                // global type & cluster admin -> local roles only
                return role.get( 'cluster' ) !== null;
            } );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/types.form.bound-roles.js